import { Component, OnInit } from '@angular/core';
import { Producto } from 'src/app/core/dtos/producto';
import { CurrentUserService } from 'src/app/core/services/current-user.service';
import { ProductoService } from 'src/app/services/producto/producto.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { BreadcrumbsComponent } from '../../shared/breadcrumbs/breadcrumbs.component';


@Component({
  selector: 'app-lista-productos',
  imports: [CommonModule,RouterModule,BreadcrumbsComponent],
  templateUrl: './lista-productos.component.html',
  styleUrl: './lista-productos.component.css',
  standalone: true
})
export class ListaProductosComponent implements OnInit {
productos: Producto[] = [];
  loading = true;
  usuarioId: number=0;
  constructor(
    private productoService: ProductoService,
    private currentUserService: CurrentUserService,
    private router: Router
  ) { }

  ngOnInit(): void {
    const usuarioId = this.currentUserService.getUsuarioId();
    if (!usuarioId) {
      alert('Debes iniciar sesión para acceder a esta sección.');
      this.router.navigate(['/login']);
      return;
    }
    this.usuarioId = +usuarioId;
    this.cargarProductos();
  }

  cargarProductos() {
    this.loading = true;
    this.productoService.getProductos(this.usuarioId).subscribe({
      next: res => {
        this.productos = res.filter(p => !p.eliminado);
        this.loading = false;
      },
      error: err => {
        console.error(err);
        this.loading = false;
      }
    });
  }

  eliminarProducto(id: number) {
    if (!confirm('¿Está seguro de eliminar este producto?')) return;
    this.productoService.eliminarProducto(id).subscribe({
      next: () => {
        alert('Producto eliminado correctamente');
        this.cargarProductos();
      },
      error: () => alert('Error al eliminar producto')
    });
  }
  volverAtras() {
    this.router.navigate(['/dashboard']);
  }
}
